import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { generateUniqueKeywords } from "../../../js/helpers/keywordHelpers";

export default function MyEditorTextInput({
  text,
  placeholder = "Enter a job description*",
  maxWords = 900,
  minWords = 20,
  readOnly = false,
  isError = false,
  ...props
}) {
  const words = generateUniqueKeywords(text.replace(/<[^>]+>/g, " "));

  return (
    <>
      <div
        style={
          isError
            ? {
                border: "1px solid #e0b4b4",
                borderRadius: ".28571429rem",
                backgroundColor: "#FFF6F6",
              }
            : { border: "1px solid #bce0fd", borderRadius: ".28571429rem" }
        }
      >
        <ReactQuill
          id="my-editor-text-input-id"
          className="my-editor-text-input"
          theme="snow"
          placeholder={placeholder}
          {...props}
          readOnly={readOnly}
          modules={{
            clipboard: {
              matchVisual: false,
            },
          }}
        />
      </div>
      <div style={{ float: "right", fontSize: 16, padding: "1px 10px 0 0" }}>
        <span
          className="bold-text"
          style={
            words.length > maxWords || words.length < minWords
              ? { color: "#db2828" }
              : {}
          }
        >
          {words.length}
        </span>
        <span>/{maxWords.toString()} words </span>
        <span className="semi-bold" style={{ fontSize: 15 }}>
          (min. {minWords.toString()} words)
        </span>
      </div>
    </>
  );
}
